import type Component from "../Component.ts";
import { getSingleParameter } from "../JobObjectHelper.ts";

const IMPLEMENTATION_ID = -1773186829

export interface PythonComponentDetails {
    interpreter: string
    length: number
    lineCount: number
    script: string
    imports: string[]
}

export function pythonComponent(component: Component): PythonComponentDetails | undefined {
    if(component.implementationID !== IMPLEMENTATION_ID) return undefined
    const interpreter = getSingleParameter(component, 3) ?? "-- Unknown"
    const script = getSingleParameter(component, 2) ?? "-- Unknown"
    return {
        interpreter,
        script,
        imports: simpleGetImports(script),
        length: script.length,
        lineCount: script.split('\n').length
    }
}

function simpleGetImports(pythonScript: string): string[] {
    // Do a really simplistic check for imports, skip any lines which start with '#'
    // Take in to account both 'import a' and 'import a as b' and 'from a import b'
    const lines = pythonScript
        .split('\n')
        .filter(line => !line.startsWith('#'))
        .map(line => line.trim())

    const standardImports = lines.filter(line => line.startsWith('import '))
        .map(line => line.split(' ')[1])
    const fromImports = lines.filter(line => line.startsWith('from '))
        .map(line => line.split(' ')[1])
    return [...standardImports, ...fromImports]
}

export function includesCursor(pythonScript: string): boolean {
    const lines = pythonScript
        .split('\n')
        .filter(line => !line.startsWith('#'))
        .map(line => line.trim())
    return lines.some(line => line.includes("context.cursor()"))
}